/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Check_OkInputs */

const cs_portals_check_ok = /** @type {(inputs: Portals_Check_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inzerát je připravený k exportu na portál.`)
};

const en_portals_check_ok = /** @type {(inputs: Portals_Check_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing is ready to export to the portal.`)
};

/**
* | output |
* | --- |
* | "Listing is ready to export to the portal." |
*
* @param {Portals_Check_OkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_check_ok = /** @type {((inputs?: Portals_Check_OkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Check_OkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_check_ok(inputs)
	return cs_portals_check_ok(inputs)
});